import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "hidden lg:block"
}
const _hoisted_2 = { class: "w-80 sm:w-96" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h5", { class: "text-lg mb-3 px-3 pt-3" }, " Farm Incentives ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-500 font-medium mb-2 text-left" }, " Pending Rewards ", -1)
const _hoisted_5 = { class: "text-xl font-medium truncate flex items-center" }
const _hoisted_6 = {
  key: 0,
  class: "text-xl font-medium truncate flex items-center"
}
const _hoisted_7 = { class: "text-sm text-gray-500 font-medium mt-1 text-left" }
const _hoisted_8 = { class: "grid grid-cols-2 gap-x-2 gap-y-2 px-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-500 font-medium mb-2 text-left" }, " Total Deposit ", -1)
const _hoisted_10 = { class: "text-xl font-medium truncate flex items-center" }
const _hoisted_11 = { class: "text-sm text-gray-500 font-medium mt-1 text-left" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-500 font-medium mb-2 text-left" }, " Average APR ", -1)
const _hoisted_13 = { class: "text-xl font-medium truncate flex items-center" }
const _hoisted_14 = { class: "text-sm text-gray-500 font-medium mt-1 text-left" }
const _hoisted_15 = { class: "mx-2 mb-2 mt-2" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Harvest All Rewards ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarsIcon = _resolveComponent("StarsIcon")
  const _component_BalLoadingIcon = _resolveComponent("BalLoadingIcon")
  const _component_BalBtn = _resolveComponent("BalBtn")
  const _component_BalCard = _resolveComponent("BalCard")
  const _component_BalPopover = _resolveComponent("BalPopover")

  return (_openBlock(), _createBlock(_component_BalPopover, { "no-pad": "" }, {
    activator: _withCtx(() => [
      _createVNode(_component_BalBtn, {
        color: "white",
        class: "mr-2 text-base",
        size: _ctx.upToLargeBreakpoint ? 'md' : 'sm',
        circle: _ctx.upToLargeBreakpoint
      }, {
        default: _withCtx(() => [
          (
            _ctx.upToLargeBreakpoint ? !(_ctx.isLoadingPools && _ctx.isLoadingFarms) : true
          )
            ? (_openBlock(), _createBlock(_component_StarsIcon, {
                key: 0,
                class: { 'mr-2': !_ctx.upToLargeBreakpoint }
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          (_ctx.harvesting || _ctx.isLoadingPools || _ctx.isLoadingFarms)
            ? (_openBlock(), _createBlock(_component_BalLoadingIcon, {
                key: 1,
                size: "sm"
              }))
            : (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString(_ctx.data.pendingRewardValue), 1))
        ]),
        _: 1
      }, 8, ["size", "circle"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_BalCard, { class: "mx-2 mb-2" }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.data.pendingBeets), 1),
            (_ctx.data.hasPendingRewardToken)
              ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.data.pendingRewardToken), 1))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.data.pendingRewardValue), 1)
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_BalCard, { class: "" }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.data.totalBalance), 1),
              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.data.numFarms) + " " + _toDisplayString(_ctx.data.numFarms === 1 ? 'Farm' : 'Farms'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_BalCard, null, {
            default: _withCtx(() => [
              _hoisted_12,
              _createVNode("div", _hoisted_13, _toDisplayString(_ctx.data.apr), 1),
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.data.dailyApr) + " Daily ", 1)
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_BalBtn, {
            type: "submit",
            "loading-label": "Harvesting",
            disabled: !_ctx.hasFarmRewards,
            loading: _ctx.harvesting,
            onClick: _ctx.harvestAllRewards,
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["disabled", "loading", "onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}